/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core EXT Release 1.0.0.a
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
    HttpClient, HttpHeaders,
    HttpResponse, HttpEvent, HttpParams
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Account } from '../_models/account.interface';
import { OperationList } from '../_models/operationlist.interface';
import { AccountOperationPayoutList, PaymentProcess, Payout, PSPOperation } from '../_models';
import { AppConfig } from '../_helpers/appconfig.service';
import { catchError } from 'rxjs/operators';
import { CustomHttpUrlEncodingCodec } from '../encoder';
@Injectable()
export class AccountService {

    _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

    protected kcmssvcURL = this._kcmssvcURL;

    public defaultHeaders = new HttpHeaders();

    constructor(protected httpClient: HttpClient) {

    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * get_account
     * Get Account
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccount(publicId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getAccount.');
        }

        let headers = this.defaultHeaders;

        return this.httpClient.get<Account>(`${this.kcmssvcURL}/accounts/${encodeURIComponent(String(publicId))}`,
            {
                withCredentials: null,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }//end 






    /**
     * create_account
     * create_account
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAccount(body: Account, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createAccount.');
        }

        return this.httpClient.post<Account>(`${this.kcmssvcURL}/accounts`,
            body,
            {

            }
        );
    }//end



    /**
     * get_account_operation_list
     * Get Account Operation List
     * @param publicId 
     * @param startDate 
     * @param endDate 
     * @param limit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccountOperationList(publicId: string, startDate?: string, endDate?: string, limit?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getAccountOperationList.');
        }

        return this.httpClient.get<Array<OperationList>>(`${this.kcmssvcURL}/accounts/${encodeURIComponent(String(publicId))}/operations`,
            {

            }
        );
    }//end

    /**
     * get_account_operation_list PSP NEW
     * Get Account Operation List PSP NEW
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccountOperationListPSPNew(publicId: string): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Account OperationList PSP.');
        }

        return this.httpClient.get<Array<PSPOperation>>(`${this._kcmssvcURL}/psp_operations?account_id=${encodeURIComponent(String(publicId))}&status=all`,
            {

            }
        );

    }//end


    /**
     * get_account_operation_list Bank
     * Get Account Operation List Bank
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccountOperationListBank(publicId: string): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Account OperationList Bank.');
        }

        return this.httpClient.get<Array<PSPOperation>>(`${this._kcmssvcURL}/psp_operations?account_id=${encodeURIComponent(String(publicId))}&status=all`,
            {

            }
        );

    }//end

    /**
     * get_account_operation_list Collect
     * Get Account Operation List Collect
     * @param publicId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccountOperationListCollect(publicId: string): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Account Operation List Collect.');
        }

        return this.httpClient.get<Array<PSPOperation>>(`${this.kcmssvcURL}/accounts/${encodeURIComponent(String(publicId))}/operations`,
            {

            }
        );
    }//end



    public AccountImport(body: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling Account Import.');
        }
        let headers = this.defaultHeaders;
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        return this.httpClient.post<any>(`${this._kcmssvcURL}/parsing-process`,
            body,
            {
                observe: 'response'
                , headers: headers

            }
        );

    }//end


    public accountImportStep1(observe: any = 'body'): Observable<any> {


        return this.httpClient.post<any>(`${this._kcmssvcURL}/parsing-process/launch`,
            {
                observe: 'response'
            }
        );

    }//end

    public accountImportStep2(observe: any = 'body'): Observable<any> {
        return this.httpClient.post<any>(`${this._kcmssvcURL}/accounts-sync-process/launch`,
            {
                observe: 'response'
            }
        );

    }//end

    public accountImportStep3(observe: any = 'body'): Observable<any> {
        return this.httpClient.post<any>(`${this._kcmssvcURL}/payments-process/launch`,
            {
                observe: 'response'
            }
        );

    }//end

    public getAccountOperationPayoutList(publicId: string, status: string, search: string, startDate: string, endDate: string, limit: number = 2000, start: number = 0): Observable<AccountOperationPayoutList> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Account Operation Payout List.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (status !== undefined && status !== null && status.toString() !== '') {
            queryParameters = queryParameters.set('operation_type', status);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search_term', search);
        }

        if (startDate != undefined && startDate.toString() !== '') {
            queryParameters = queryParameters.set('start_date', <string>startDate);
        }

        if (endDate != undefined && endDate.toString() !== '') {
            queryParameters = queryParameters.set('end_date', <string>endDate);
        }

        if (start !== undefined && start !== null && start.toString() !== '') {
            queryParameters = queryParameters.set('start', start.toString());
        }

        if (limit !== undefined && limit !== null && limit.toString() !== '') {
            queryParameters = queryParameters.set('limit', limit.toString());
        }

        return this.httpClient.get<AccountOperationPayoutList>(`${this.kcmssvcURL}/accounts/${encodeURIComponent(String(publicId))}/operations`,
            {
                params: queryParameters
            }
        );
    }

    cashIn(body: any): Observable<any>  {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.httpClient.post(`${this.kcmssvcURL}/payout_process/cash-in`, body,
          {
            observe: 'response',
            headers: headers
          }
        ).pipe(catchError(this.formatErrors));;
      }

      private formatErrors(error: any) {
        return throwError(error);
    }

    getPayoutAccountConfigurationsDetails(publicId: string){
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling get Account Configurations.');
        }
        return this.httpClient.get<any>(`${this.kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/account.setup`).toPromise();
    }
}//end class
